import { Component, ElementRef, OnInit, QueryList, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnimationService } from 'src/app/services/animation/animation.service';
import { CursorService } from 'src/app/services/cursor_animation/cursor.service';
import { ProjectRouteService } from 'src/app/services/project/project-route.service';

@Component({
    selector: 'app-projects-slider',
    templateUrl: './projects-slider.component.html',
    styleUrls: ['./projects-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProjectsSliderComponent implements OnInit {
  @ViewChildren('textContent') textContent!: QueryList<ElementRef>;

  route: any;
  isHidden: boolean = false
  constructor(
    private cursorService: CursorService,
    private routes : ProjectRouteService,
    private animate : AnimationService
    ) { 

  }

  ngOnInit(): void {
      setTimeout(() => {      
      
        const elements = this.textContent.toArray().map(el => el.nativeElement);
        this.animate.fadeOutElementsOnScroll(elements);
        this.animate.fadeInElements(elements, 0.15);
    }, 6000);

    this.routes.getProjectName().subscribe((res:any)=>{

    })
  }

  onMouseEnter(): void {
    this.cursorService.hoverElement();
  }

  onMouseLeave(): void {
    this.cursorService.unhoverElement();
  }

  onMouseColorChange(color: string){
    this.cursorService.changeCursorColor(color)
  }
  onChangeColorBack(color: string){
    this.cursorService.changeCursorColorBack(color)
  }

}
